
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class GridLayout extends BaseComponent {
	
	constructor() {
		super();		
	}
	
	render() {	
		return html`
			.container {
				display: grid;
				grid-template-columns: auto auto auto;
				align-items: stretch;
				justify-items: stretch;
				gap: 10px 10px;
			}
		
			<div class='container'>
				<slot></slot>
			<div>
		`;
	}
		
};
customElements.define('dl-grid-layout', GridLayout);
